import { Component, ChangeDetectionStrategy, Input, ElementRef, ViewChild, OnInit, HostListener } from '@angular/core';
import { AbstractInputComponent } from '@shared/form-elements/input/abstract-input/abstract-input.component';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { ValidationErrorMessagePipe } from '@shared/form-elements/pipes/validation-error-message.pipe';
import { FirstKeyPipe } from '@shared/form-elements/pipes/first-key.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '../../../svg-icon/svg-icon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-input-textarea',
    templateUrl: './input-textarea.component.html',
    styleUrls: ['./input-textarea.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgIf, FormsModule, ReactiveFormsModule, SvgIconComponent, TranslateModule, FirstKeyPipe, ValidationErrorMessagePipe, ControlToKeyNamePipe]
})
export class InputTextareaComponent extends AbstractInputComponent implements OnInit {
    public focused = false;

    @ViewChild('textareaRef') public textareaRef: ElementRef<HTMLInputElement>;

    @Input()
    public maxlength: number = 200;

    @Input()
    public showCounter: boolean = false;

    @Input()
    public helpText?: string;

    @Input()
    public allowNewLines: boolean = true;

    @HostListener('keypress', ['$event'])
    public onKeyPress(event: KeyboardEvent): void {
        if (!this.allowNewLines && event.key === 'Enter') {
            event.preventDefault();
        }
    }

    public ngOnInit(): void {
        this.trimValue();
    }

    public get showError(): boolean {
        return !!(this.control.touched && this.control.errors);
    }

    public get showValid(): boolean {
        return !this.showError && this.focused && this.control.touched;
    }

    public onFocus(): void {
        this.focused = true;
    }

    public onBlur(): void {
        this.focused = false;
        this.inputBlur.emit();
        this.trimValue();
    }

    private trimValue(): void {
        // if you copy past the text
        const value: string = this.control.value;
        const regex = new RegExp('\\r?\\n|\\r', 'gm');

        if (!this.allowNewLines && regex.test(value)) {
            this.control.patchValue(value.replace(regex, ' '));
        }

        if (value.length > this.maxlength) {
            this.control.patchValue(value.substring(0, this.maxlength));
        }
    }
}
